import React, { useState, useEffect, useContext } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

import { ValidationsService } from "../../utility/services/ValidationsService";
import { AuthContext } from "../../utility/services/AuthContext";
import Functions from "../../utility/services/Functions";
import { toast } from "react-toastify";

import ApiService from "../../utility/services/ApiService";
import SuccessIcon from "../images/success.svg";
import Modal from "react-bootstrap/Modal";
import Image from "react-bootstrap/Image";
import AOS from "aos";

const Contact = () => {
  // LOGICAL VARIABLES
  useEffect(() => {
    AOS.init({
      // ... your other initialisation options here ...
      once: true,
    });
  }, []);

  const { setLoading, user } = useContext(AuthContext);
  const isUser = user.access_token;
  const { consoleService } = Functions();
  const [validationsRes, setValidationsRes] = useState({});
  const { public_contact_us, user_contact_us } = ApiService();
  const [modalShow, setModalShow] = React.useState(false);
  const [submit, setSubmit] = useState(false);

  const validationErrStyle = {
    position: "relative",
    top: -30,
    left: -10,
  };

  // DATA VARIABLES
  const [name, setName] = useState("");
  const [last_name, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [query, setQuery] = useState("");

  // USE EFFECTS

  useEffect(() => {
    validationsResFun();
  }, [name, last_name, email, phone, query]);

  // FUNCTIONS

  function validationsResFun() {
    setValidationsRes(
      ValidationsService({
        name,
        last_name: last_name,
        email,
        phone,
        query,
      })
    );
  }

  const handleMobileNumberChange = (event) => {
    const input = event.target.value.replace(/[^0-9+]/g, "");
    setPhone(input);
  };

  const submitFun = async () => {
    setSubmit(true);
    const validationCond = isUser
      ? !validationsRes.nameErr &&
        !validationsRes.lastNameErr &&
        !validationsRes.emailErr &&
        !validationsRes.phoneErr &&
        !validationsRes.queryErr
      : !validationsRes.nameErr &&
        !validationsRes.lastNameErr &&
        !validationsRes.emailErr &&
        !validationsRes.queryErr;

    if (validationCond) {
      setLoading(true);
      const data = isUser
        ? {
            user_name: `${name} ${last_name}`,
            email,
            message: query,
            subject: "Query",
            phone,
          }
        : {
            name: `${name} ${last_name}`,
            email,
            query,
          };
      const res = isUser
        ? await user_contact_us(data)
        : await public_contact_us(data);
      if (res.status === 1) {
        setLoading(false);
        setSubmit(false);
        setName("");
        setLastName("");
        setPhone("");
        setEmail("");
        setQuery("");
        setModalShow(true);
      } else {
        setLoading(false);
        toast(res.message, {
          position: "top-center",
          hideProgressBar: true,
          type: "error",
        });
      }
    } else {
      // toast("Some fields are missing.", {
      //   position: "top-center",
      //   hideProgressBar: true,
      //   type: "error",
      // });
    }
  };

  // NESTED COMPONENT

  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        size="sm"
        className="modalSuccess"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <Image src={SuccessIcon} alt="" />
          <h4>Success</h4>
          <p>Thanks, We will get in touch with you asap.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              setModalShow(false);
            }}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  return (
    <Form className="contact_pad">
      <div className="row">
        <div className="col-lg-6">
          <Form.Label>First Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter first name"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
          {submit && validationsRes.nameErr && (
            <span className="validations_err" style={validationErrStyle}>
              {validationsRes.nameErr}
            </span>
          )}
        </div>
        <div className="col-lg-6">
          <Form.Label>Last Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter last name"
            value={last_name}
            onChange={(e) => {
              setLastName(e.target.value);
            }}
          />
          {submit && validationsRes.lastNameErr && (
            <span className="validations_err" style={validationErrStyle}>
              {validationsRes.lastNameErr}
            </span>
          )}
        </div>
        <div className="col-lg-12">
          {isUser && (
            <>
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                type="text"
                value={phone}
                placeholder="Your Number"
                onChange={handleMobileNumberChange}
              />
              {submit && validationsRes.phoneErr && (
                <span className="validations_err" style={validationErrStyle}>
                  {validationsRes.phoneErr}
                </span>
              )}
            </>
          )}
        </div>
        <div className="col-lg-12">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter email address"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
          {submit && validationsRes.emailErr && (
            <span className="validations_err" style={validationErrStyle}>
              {validationsRes.emailErr}
            </span>
          )}
        </div>
        <div className="col-lg-12">
          <Form.Label>Your Query</Form.Label>
          <Form.Control
            placeholder="Enter message here"
            as="textarea"
            rows={3}
            value={query}
            onChange={(e) => {
              setQuery(e.target.value);
            }}
          />
          {submit && validationsRes.queryErr && (
            <span className="validations_err" style={validationErrStyle}>
              {validationsRes.queryErr}
            </span>
          )}
        </div>
      </div>
      <Button
        variant="outline-light"
        onClick={() => {
          submitFun();
        }}
      >
        Send message
      </Button>
      <MyVerticallyCenteredModal show={modalShow} />
    </Form>
  );
};
export default Contact;
